var map = {
	"./Capsula v3.glb": 241,
	"./Centrossomo v17.glb": 242,
	"./Cloroplasto v6.glb": 243,
	"./Complexo de Golgi v3.glb": 244,
	"./Dna nucleoide.glb": 245,
	"./Endoplasmatic v7.glb": 246,
	"./Endoplasmático liso v2.glb": 247,
	"./Flagelo v10.glb": 248,
	"./Mesossomos v3.glb": 249,
	"./Mitocondria v15 .glb": 250,
	"./Nucleo v6.glb": 251,
	"./Paleta nova - Utopia.glb": 252,
	"./Piliv1.1.glb": 253,
	"./Plamídio.glb": 254,
	"./Plasmideos.glb": 255,
	"./Ribossomo.glb": 256,
	"./Vacuolo v8.glb": 257,
	"./citoesqueleto v2.glb": 258,
	"./citoso v1 .glb": 259,
	"./parede v3.glb": 260,
	"./teste.glb": 261,
	"./vesícula v1.glb": 262
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 240;